/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";

import { UserTableService } from "./user-table.service";
import { User } from "./user.type";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<User>;

  constructor(
    public userTableService: UserTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Life cycle method

  ngOnInit(): void {
    this.tableConfig = this.userTableService.getUsersTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddUser(): void {
    this.addUser();
  }

  // #endregion

  // #region Private methods

  private addUser(): void {
    this.router.navigate(["/users/create"]);
  }

  // #endregion
}
